module.exports = __webpack_public_path__ + "pc/media/video_pc.ebd36fbd.mp4";